<template>
    <Dashboard
        :title="__('Edit page', null, $page.props.profile_locale)"
    >
        <Heading
            :label="page.slug == 'lottery' ? __('Lottery', null, $page.props.profile_locale) : page.title"
        />
        <div class="grid grid-cols-1 gap-3">
            <div class="space-y-3">
                <InputLabel
                    id="page.title"
                    :label="__('Title', null, $page.props.profile_locale)"
                    v-model="form.page.title"
                />
                <InputLabel
                    id="page.content"
                    class="col-span-full"
                    type="quill"
                    :label="__('Content', null, $page.props.profile_locale)"
                    v-model="form.page.content"
                />

                <Button
                    @click="save"
                >
                    {{__('Save', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>

    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import IconLink from 'UI/IconLink';
    import Heading from 'COMP/Heading';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import { useForm } from '@inertiajs/inertia-vue3'
    import ImageUpload from 'UI/ImageUpload';
    import Checkbox from 'UI/Checkbox';


    export default {
        props: {
            page: [Array, Object],
        },
        components: {
            Dashboard,
            Button,
            SvgIcon,
            InputLabel,
            Heading,
            IconLink,
            ImageUpload,
            Checkbox
        },
        setup(props) {

            const form = useForm({
                page: props.page,
                aditional: {}
            })

            function save(){
                form.post(route('dashboard.pages.update', props.page.id), {
                    preserveScroll: true,
                })
            }

            return {
                form,
                save,
            }
        },

    }
</script>
